module.exports = __webpack_public_path__ + "img/icon1.b31251bb.png";